import { Component, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChildrenSelectorComponent, Student } from '../../shared/children-selector/children-selector.component';
import { CantineService, CantineJour } from '../../services/cantine.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { PageTitleComponent } from '../../shared/page-title/page-title.component';
import Swal from 'sweetalert2';
import { AlertService } from '../../services/alert.service';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { ChangeDetectorRef } from '@angular/core';

interface SelectableStudent extends Student {
  selected: boolean;
  name: string;
}

interface Reservation {
  id: number;
  orgid: number;
  typeReservation: string;
  datedebut?: string;
  datefin?: string;
}

@Component({
  selector: 'app-contine',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    ChildrenSelectorComponent,
    PageTitleComponent ,
      LoaderComponent ], // 👈 maintenant OK],
  templateUrl: './contine.component.html',
  styleUrls: ['./contine.component.css']
})


export class ContineComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  children: SelectableStudent[] = [];
  selectedChild: SelectableStudent | null = null;

  cantineData: CantineJour[] = [];
  reservations: Reservation[] = [];
  menuImage: any = null;  // Image du menu
loading = true;
  error: string | null = null;
  currentIndex: number = 0;
  showForm: boolean = false;
  showReservationSection: boolean = false;
  isSearchForm: boolean = false;
selectedStudent: Student | null = null;
selectedStudentId: number | null = null;

  reservation = {
    dateDebut: '',
    dateFin: '',
    type: '' 
  };

  searchCriteria: { dateDebut?: string; dateFin?: string; type?: string } = {};
  filteredReservations: Reservation[] = [];

  private extractReservationsFromApi(data: any): Reservation[] {
    let list: any[] = [];

    if (Array.isArray(data)) {
      list = data;
    } else if (Array.isArray(data?.results)) {
      list = data.results;
    } else if (Array.isArray(data?.results?.studentExterneCantine)) {
      list = data.results.studentExterneCantine;
    } else if (Array.isArray(data?.studentExterneCantine)) {
      list = data.studentExterneCantine;
    }

    const normalized: Reservation[] = (list || []).map((it: any) => {
      const id = it.id ?? it.idreservation ?? it.idReservation ?? it.reservationId ?? 0;
      const orgid = it.orgid ?? it.idOrg ?? it.orgId ?? 0;
      const typeReservation = it.typeReservation ?? it.typeres ?? it.type ?? '';
      // Support both dd-MM-yyyy and yyyy-MM-dd
      const start = it.datedebut ?? it.dateDebut ?? it.startDate ?? it.date_debut ?? '';
      const end = it.datefin ?? it.dateFin ?? it.endDate ?? it.date_fin ?? '';
      return {
        id: Number(id) || 0,
        orgid: Number(orgid) || 0,
        typeReservation: String(typeReservation || ''),
        datedebut: typeof start === 'string' ? start : '',
        datefin: typeof end === 'string' ? end : ''
      } as Reservation;
    });

    return normalized;
  }

setMode(searchMode: boolean) {
  this.showReservationSection = true;
  this.showForm = true;
  this.isSearchForm = searchMode;

  if (searchMode) {
    // Définir un type par défaut
    if (!this.searchCriteria.type) this.searchCriteria.type = 'Cantine';

    // Charger les réservations si pas déjà fait
    if (this.selectedChild) {
      this.loadReservations(); // Cela met à jour `reservations`
    }

    // ⚠️ IMPORTANT : Initialiser filteredReservations dès le départ
    setTimeout(() => {
      this.applySearchFilter(); // Cela va copier `reservations` → `filteredReservations` si pas de filtre actif
    }, 0);
  }
}

  private mapTypeForApi(type?: string | null): string {
    const t = (type || '').toLowerCase();
    if (t === 'cantine') return 'cantine';
    if (t === 'gouter' || t === 'snack') return 'gouter';
    // Default server category for listing if undefined
    return 'cantine';
  }

  private mapTypeForPost(type?: string | null): string {
    const t = (type || '').toLowerCase();
    if (t === 'cantine') return 'Cantine';
    if (t === 'gouter' || t === 'snack') return 'Gouter';
    return 'Cantine';
  }

  parentId: number | null = null;
constructor(
  private cantineService: CantineService,
  @Inject(PLATFORM_ID) private platformId: Object,
  private alertService: AlertService,
  private cdr: ChangeDetectorRef
) {}


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.loadParentId();
    this.loadChildren();
      setTimeout(() => {
    this.loading = false; // simulation API
  },5000);
  }

  private loadParentId() {
    if (!isPlatformBrowser(this.platformId)) return;

    const userStr = localStorage.getItem('userData');
    if (!userStr) return;

    try {
      const user = JSON.parse(userStr);
      this.parentId = user?.idGuardian ?? user?.id ?? null;
    } catch (err) {
      console.error('Erreur parsing userData', err);
      this.parentId = null;
    }
  }


loadChildren() {
  if (!isPlatformBrowser(this.platformId)) return;

  let allStudents: any[] = [];
  const studentListStr = localStorage.getItem('studentList');
  if (studentListStr) {
    try { allStudents = JSON.parse(studentListStr) as any[]; } catch {}
  }
  // Fallback: try from userData.listStudent
  if (!Array.isArray(allStudents) || allStudents.length === 0) {
    const userStr = localStorage.getItem('userData');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (Array.isArray(user?.listStudent)) {
          allStudents = user.listStudent as any[];
        }
      } catch {}
    }
  }
  if (!Array.isArray(allStudents)) allStudents = [];

  const filtered = this.parentId
    ? allStudents.filter((s: any) => s.idGuardian === this.parentId)
    : allStudents;

  this.children = filtered.map((s: any) => ({ ...s, selected: false, name: s.nameStudent }));


  if (this.children.length > 0 && !this.selectedChild) {
    this.selectChild(this.children[0], false);
    this.selectedStudentId = this.children[0].idStudent;
    this.selectedStudent = this.children[0];
  }
}


ngAfterViewInit(): void {
  if (this.children.length > 0) {
    this.selectedChild = this.children[0];
    this.selectedStudentId = this.children[0].idStudent;

    // 🔄 Forcer Angular à détecter ce changement
    this.cdr.detectChanges();
  }
}


  // Appelé quand l'enfant est sélectionné dans le ChildrenSelectorComponent
// Appelé quand l'enfant est sélectionné dans le ChildrenSelectorComponent
onStudentSelected(student: Student) {
  // Trouver l'enfant complet dans la liste
  const child = this.children.find(c => c.idStudent === student.idStudent);
  if (child) {
    this.selectChild(child); // triggerEvent est true par défaut
  }
}

// Recevoir la liste depuis le composant sélecteur
onStudentsLoaded(students: Student[]) {
  // Utiliser directement la liste fournie (le sélecteur gère déjà le filtrage si besoin)
  this.children = (students || []).map(s => ({ ...s, selected: false, name: s.nameStudent }));

  if (this.children.length > 0) {
    // Si aucun enfant sélectionné, sélectionner le premier
    if (!this.selectedChild) {
      this.selectChild(this.children[0], false);
      this.selectedStudentId = this.children[0].idStudent;
      this.selectedStudent = this.children[0];
    }
  }
}

// Sélection d'un enfant et chargement des données
// Sélection d'un enfant et chargement des données
selectChild(child: SelectableStudent, triggerEvent: boolean = true) {
  this.children.forEach(c => (c.selected = false));
  child.selected = true;
  this.selectedChild = child;

  // Charger les données
  this.loadCantine();
  this.loadReservations();

  // Déclencher l'événement seulement si demandé
  if (triggerEvent && this.selectedStudentId !== child.idStudent) {
    this.selectedStudentId = child.idStudent; // Mettre à jour la propriété liée
    this.selectedStudent = child; // Mettre à jour la référence
    // Note: L'événement (studentSelected) sera émis par le ChildrenSelectorComponent
    // en réaction au changement de selectedStudentId, ce qui est correct pour une interaction utilisateur.
  }
}

// Charger le menu cantine pour l'enfant sélectionné
loadCantine(): void {
  if (!this.selectedChild) return;

  const { idStudent, batchId, idUserStudent, idOrg } = this.selectedChild;

  this.loading = true;
  this.error = null;

  // Vérifier la configuration de l'organisation pour décider du comportement
  this.cantineService
    .getOrganizationConfiguration(idOrg)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: config => {
        const typeCantine = (config?.response?.typecantine || '').toLowerCase();

        if (typeCantine === 'photo' || typeCantine === 'image') {
          // Si la configuration indique une photo, charger uniquement l'image
          this.menuImage = null;
          this.cantineData = [];

          this.cantineService
            .getMenuWithImage(idOrg)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: menuData => {
                if (menuData?.response?.path) {
                  this.menuImage = menuData.response;
                } else {
                  this.menuImage = null;
                }
                this.loading = false;
              },
              error: err => {
                console.warn('Menu image not available:', err);
                this.menuImage = null;
                this.loading = false;
              }
            });
        } else {
          // Sinon, charger le menu détaillé (liste des repas)
          this.menuImage = null;
          this.cantineService
            .getCantineByStudent(idOrg, idUserStudent, idStudent, batchId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data: any) => {
                console.log('Cantine API raw data:', data);

                let list: any[] = [];
                if (Array.isArray(data)) {
                  list = data;
                } else if (Array.isArray((data as any)?.response)) {
                  list = (data as any).response;
                } else if (Array.isArray((data as any)?.results)) {
                  list = (data as any).results;
                } else if (Array.isArray((data as any)?.data)) {
                  list = (data as any).data;
                }

                this.cantineData = Array.isArray(list) ? list : [];

                if (this.cantineData.length > 0) {
                  const todayIso = new Date().toISOString().slice(0,10);
                  const idx = this.cantineData.findIndex((d:any) => (d?.date || '').slice(0,10) === todayIso);
                  this.currentIndex = idx >= 0 ? idx : 0;
                } else {
                  this.currentIndex = 0;
                }

                console.log('Processed cantineData length:', this.cantineData.length, 'currentIndex:', this.currentIndex);

                this.loading = false;
                this.cdr.detectChanges();
              },

              error: err => {
                this.error = 'Erreur chargement cantine';
                this.loading = false;
                console.error(err);
              }
            });
        }
      },
      error: err => {
        // Si la récupération de la configuration échoue, revenir au comportement précédent
        console.warn('Organisation config not available, fallback to image+menu:', err);

        // Essayer de charger l'image (si disponible)
        this.cantineService
          .getMenuWithImage(idOrg)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: menuData => {
              if (menuData?.response?.path) {
                this.menuImage = menuData.response;
              }
            },
            error: _ => {
              this.menuImage = null;
            }
          });

        // Charger également les repas détaillés
        this.cantineService
          .getCantineByStudent(idOrg, idUserStudent, idStudent, batchId)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: data => {
              this.cantineData = data || [];
              this.loading = false;
              this.currentIndex = 0;
            },
            error: err2 => {
              this.error = 'Erreur chargement cantine';
              this.loading = false;
              console.error(err2);
            }
          });
      }
    });
}

// Charger les réservations pour l'enfant sélectionné
loadReservations(): void {
  if (!this.selectedChild) return;

  const { idStudent, idOrg } = this.selectedChild;
  const typeres = this.mapTypeForApi('cantine');

  const currentYear = new Date().getFullYear();
  const dateDebut = `${currentYear}-01-01`;
  const dateFin = `${currentYear}-12-31`;

  this.cantineService
    .getReservationsByStudent(idStudent, typeres, dateDebut, dateFin)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: data => {
        // Adapter selon le format réel de l'API
        this.reservations = this.extractReservationsFromApi(data);
        this.applySearchFilter();
      },
      error: err => console.error('Erreur récupération réservations', err)
    });
}


  // Afficher le formulaire de réservation
  showReservationForm(): void {
    this.showReservationSection = true;
    this.showForm = true; // Afficher le formulaire
  }

reserver(): void {
  if (!this.selectedChild) {
    this.alertService.showError({
      title: 'Erreur',
      message: 'Veuillez sélectionner un étudiant'
    });
    return;
  }

  if (!this.reservation.dateDebut || !this.reservation.dateFin || !this.reservation.type) {
    this.alertService.showError({
      title: 'Erreur',
      message: 'Veuillez remplir toutes les dates'
    });
    return;
  }

  const dateDebutFormatted = this.reservation.dateDebut;
  const dateFinFormatted = this.reservation.dateFin;

  const start = new Date(this.reservation.dateDebut);
  const end = new Date(this.reservation.dateFin);
  if (isFinite(start.getTime()) && isFinite(end.getTime()) && start > end) {
    this.alertService.showError({ title: 'Erreur', message: 'La date de début doit être avant la date de fin.' });
    return;
  }

  this.alertService.showConfirmation({
    title: 'Confirmation',
    message: `Êtes-vous sûr de vouloir réserver ${this.reservation.type.toLowerCase() === 'gouter' ? 'le goûter' : 'la cantine'} du ${dateDebutFormatted} au ${dateFinFormatted} ?`
  }).then((isConfirmed) => {
    if (!isConfirmed) return;

    const payload = {
      dateDebut: dateDebutFormatted,
      dateFin: dateFinFormatted,
      type: this.mapTypeForPost(this.reservation.type),
      idstudent: String(this.selectedChild!.idStudent),
      idreservation: '-99',
      orgid: String(this.selectedChild!.idOrg)
    };

    this.cantineService.reserverCantine(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          // ✅ lire type et msg depuis res.response
          if (res?.response?.type === 'success') {
            this.alertService.showSuccess({ message: res.response.msg || 'Réservation effectuée avec succès !' });
            setTimeout(() => this.loadReservations(), 500);
          } else {
            this.alertService.showError({
              title: 'Erreur',
              message: res?.response?.msg || 'La réservation a échoué.'
            });
          }

          this.showForm = false;
          this.reservation = { dateDebut: '', dateFin: '', type: '' };
        },
        error: (err: any) => {
          console.error('❌ Erreur lors de la réservation :', err);
          const backendMsg =
            err?.error?.response?.msg ||
            err?.error?.msg ||
            err?.error?.message ||
            err?.message ||
            'Erreur lors de la réservation';
          this.alertService.showError({
            title: 'Erreur',
            message: backendMsg
          });
        }
      });
  });
}


rechercherReservations() {
  if (!this.selectedChild) return;

  const startIso = this.searchCriteria.dateDebut || '2025-01-01';
  const endIso = this.searchCriteria.dateFin || '2025-12-31';
  const type = this.mapTypeForPost(this.searchCriteria.type || 'cantine');

  const payload = {
    idStudent: this.selectedChild.idStudent,
    type,
    beginDate: startIso,
    endDate: endIso
  };

  this.cantineService.searchReservations(payload)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (res: any) => {
        // ⚠️ Les données sont dans res.response (selon la nouvelle API)
        const list = this.extractReservationsFromApi(res?.response || []);
        this.reservations = list;
        this.applySearchFilter();
      },
      error: (err) => {
        console.error('❌ Erreur recherche réservations:', err);
        this.alertService.showError({ title: 'Erreur', message: 'Erreur lors de la recherche.' });
      }
    });
}


applySearchFilter() {
  if (!this.isSearchForm) {
    this.filteredReservations = this.reservations;
    return;
  }

  const normalize = (v: string | undefined | null) => (v || '').toLowerCase();
  const start = this.searchCriteria.dateDebut ? new Date(this.searchCriteria.dateDebut) : null;
  const end = this.searchCriteria.dateFin ? new Date(this.searchCriteria.dateFin) : null;
  // Canonicalize input type using same API mapping so 'Contine' matches 'Cantine'
  const type = normalize(this.mapTypeForApi(this.searchCriteria.type as any));

  this.filteredReservations = (this.reservations || []).filter(r => {
    let ok = true;
    if (start) {
      // r.datedebut est supposé dd-MM-yyyy
      const [dd, mm, yyyy] = (r.datedebut || '').split('-');
      const d = dd && mm && yyyy ? new Date(`${yyyy}-${mm}-${dd}`) : null;
      if (d && d < start) ok = false;
    }
    if (ok && end) {
      const [dd2, mm2, yyyy2] = (r.datefin || r.datedebut || '').split('-');
      const d2 = dd2 && mm2 && yyyy2 ? new Date(`${yyyy2}-${mm2}-${dd2}`) : null;
      if (d2 && d2 > end) ok = false;
    }
    if (ok && type) {
      // Canonicalize reservation type as well
      const resTypeCanonical = normalize(this.mapTypeForApi(r.typeReservation));
      ok = resTypeCanonical === type;
    }
    return ok;
  });

  // Reset pagination on new filter and show section if hidden
  this.currentPage = 1;
  if (this.isSearchForm) {
    this.showReservationSection = true;
    this.showForm = true;
  }
}

supprimer(reservation: Reservation): void {
  if (!this.selectedChild) return;

  this.alertService.showDeleteConfirmation(
    { title: 'Confirmation de suppression', message: 'Êtes-vous sûr de vouloir supprimer cette réservation de cantine ?' }
  ).then((isConfirmed) => {
    if (!isConfirmed) return;

    // Utiliser l'ID de la réservation
    const idReservation = reservation.id;

    this.cantineService.supprimerReservation(idReservation)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const msg = res?.response || 'Réservation supprimée avec succès';
          this.alertService.showSuccess({ title: 'Succès', message: msg });
          this.loadReservations();
        },
        error: (err: any) => {
          console.error('Error deleting reservation:', err);
          const backendMsg = err?.error?.response || err?.error?.msg || err?.message || 'Erreur lors de la suppression';
          this.alertService.showError({ title: 'Erreur', message: backendMsg });
        }
      });
  });
}

// Pagination
pageSize = 5; // nombre de réservations par page
currentPage = 1;

get paginatedReservations() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;
  return this.reservations.slice(start, end);
}

totalPages(): number {
  return Math.ceil(this.reservations.length / this.pageSize);
}

prevPage() {
  if (this.currentPage > 1) this.currentPage--;
}

nextPage() {
  if (this.currentPage < this.totalPages()) this.currentPage++;
}

  prevDay() {
    if (this.currentIndex > 0) this.currentIndex--;
  }

  nextDay() {
    if (this.currentIndex < this.cantineData.length - 1) this.currentIndex++;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}